/*------------------------------------*\
    popup
\*------------------------------------*/

module.exports = function(){

    var $popupTrigger = $('.js-popup-trigger');
    var $popup = $('.js-popup');

    $popupTrigger.hover(function() {
        var $popupData = $(this).data('popup');
        var $popupPosition = $(this).position();
        var $popupHeight = $(this).height();
        $popup.addClass('is-active').css({'top': $popupPosition.top + $popupHeight, 'left': $popupPosition.left - 20}).text($popupData);
    }, function() {
        $popup.removeClass('is-active').text();
    });


}; // end of module.exports



// WEBPACK FOOTER //
// ./js-source/blocks/popup.js